import { LegalTeamStarMisc } from "../SVGDump"

import '../../../component_styles/plus/overflow-offpage.css'
import '../../../component_styles/landing/homepage/legal_team_section.css'

const LegalTeamSect = () => {
    const legalTeamMembersInfo = [
        {
            name: "Daniella Acevedo",
            position: "Senior Associate",
            location: "Toronto",
            image_url: "https://res.cloudinary.com/derzcse6f/image/upload/v1750648083/Acevedo_Daniela_kg0fxi.jpg"
        },
        {
            name: "Roberto Alburto",
            position: "Partner",
            location: "Ottawa",
            image_url: "https://res.cloudinary.com/derzcse6f/image/upload/v1750648083/Aburto_Roberto_takjxa.jpg"
        },
        {
            name: "Stephanie Abrutyn",
            position: "Counsel",
            location: "New york",
            image_url: "https://res.cloudinary.com/derzcse6f/image/upload/v1750648083/Abrutyn_Stephanie_vxgmkc.jpg"
        },
        {
            name: "Seth K. Abrams",
            position: "Managing Associate",
            location: "New york",
            image_url: "https://res.cloudinary.com/derzcse6f/image/upload/v1750648083/Abrams_Seth_jfu9t4.jpg"
        },
        {
            name: "Nathan Abbott",
            position: "Partner",
            location: "Melbourne",
            image_url: "https://res.cloudinary.com/derzcse6f/image/upload/v1750647478/Abbott_Nathan_qreedr.jpg"
        },
        {
            name: "Sarah Abi Raad",
            position: "Associate",
            location: "London",
            image_url: "https://res.cloudinary.com/derzcse6f/image/upload/v1750648082/Abi_Raad_Sarah_kohdol.jpg"
        },
        {
            name: "Logan Chaney Abernathy",
            position: "Senior Managing Associate",
            location: "Huntsville",
            image_url: "https://res.cloudinary.com/derzcse6f/image/upload/v1750647518/Abernathy_Logan-Chaney_xi6v0p.jpg"
        },
        {
            name: "Carmen Abdo",
            position: "Associate",
            location: "Madrid",
            image_url: "https://res.cloudinary.com/derzcse6f/image/upload/v1750647504/Abdo_Carmen_c6bqim.jpg"
        },
    ]

    const mailLegalTeam = () => {
        const legalTeamMail = "legalteam@americannativeheartfoundation.com"
        const link=document.createElement("a")
        link["href"]=`mailto:${legalTeamMail}`
        link.click()
    }

    return(
        <div className="legal-team-section">
            <div className="legal-team-hero">
                <div className="-flex-left">
                    <div className="big-text" role="heading" aria-level="2">
                        Meet the Legal Minds Behind Our Mission
                    </div>
                    <div className="big-text-aux">
                        Our dedicated legal team ensures every action we take is ethical, compliant, and aligned with our mission to serve. 
                    </div>
                    <button onClick={mailLegalTeam}>Contact us</button>
                </div>
                <div className="flex-right">
                    <div>
                        <img src="https://res.cloudinary.com/derzcse6f/image/upload/v1750648174/gabrielle-henderson-HJckKnwCXxQ-unsplash_moh24t.jpg" alt="Law officers signing documents"/>
                        <LegalTeamStarMisc classNames={["legal-team-star-misc"]}/>
                    </div>
                    <div>
                        <img src="https://res.cloudinary.com/derzcse6f/image/upload/v1750648157/sebastian-herrmann-O2o1hzDA7iE-unsplash_xh1wep.jpg" alt="A group of White collar officers going through a document"/>
                    </div>
                    <div>
                        <img src="https://res.cloudinary.com/derzcse6f/image/upload/v1750648161/giammarco-boscaro-zeH-ljawHtg-unsplash_pgkpqj.jpg" alt="Library of books"/>
                    </div>
                </div>
            </div>
            <div className="legal-team-members overflow-offpage">
                {
                    legalTeamMembersInfo.map((member,index)=>
                    <div className="legal-team-member" key={index}>
                        <div className="legal-team-member-img">
                            <img src={member.image_url} alt={member.name}/>
                            <div className="legal-team-member-overlay"></div>
                        </div>
                        <div className="-name">{member.name}</div>
                        <div className="-title">{member.position}</div>
                        <div className="-location">{member.location}</div>
                    </div>
                    )
                }
            </div>
        </div>
    )
}

export default LegalTeamSect;